export { default as CustomAssetService } from './CustomAsset';
